import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Space, DatePicker, Drawer, Form, Input, Select, Radio, message, Modal, Pagination, Tabs } from 'antd';
import { Table, Button } from 'antd';
import { DownOutlined, ExclamationCircleOutlined, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { ICourseDefinition, listCourseDefinitions, createCourseDefinition, updateCourseDefinition, deleteCourseDefinition, pageCourseDefinitions } from '../../service/api/courseDefinition';
import moment from 'moment';
import { updateRole, createRole, IRolePermission, listRoles, listPermissions, listMenus } from '../../service/api/account';
import { FormInstance } from 'antd/lib/form/Form';
const { confirm } = Modal;
const { Option } = Select;

interface IRoleListProps {
  visible: boolean
  setVisible: (visible: boolean) => void;
}
const RoleList: React.FC<IRoleListProps> = ({
  visible,
  setVisible,
}) => {
  const [roles, setRoles] = useState<IRolePermission[]>();
  const [menus, setMenus] = useState<IRolePermission[]>();
  const [permissions, setPermissions] = useState<IRolePermission[]>();
  const [roleDetail, setRoleDetail] = useState<IRolePermission>();
  const [loading, setLoading] = useState(false);
  const formRef = React.createRef<FormInstance>();
  const columns = [
    {
      title: '角色名称',
      dataIndex: 'name',
      key: 'name',
      width: 100,
    },
    {
      title: '角色编码',
      dataIndex: 'code',
      key: 'code',
      width: 100,
    },
    {
      title: '拥有菜单',
      dataIndex: 'menus',
      key: 'menus',
    },
    {
      title: '拥有权限',
      dataIndex: 'permissions',
      key: 'permissions',
    },
    {
      title: '操作',
      key: 'action',
      width: 80,
      render: (text: any, record: any) => {
        return <Space size="middle">
          <a onClick={() => {
            // console.log("record:" + JSON.stringify(record));
            setRoleDetail(record);
            setVisible(true);
          }}>编辑 </a>
        </Space>
      },
    }
  ];

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    if (roleDetail) {
      // 设置100毫秒的延迟 确保from组件已经加载完毕
      setTimeout(() => {
        formRef.current!.setFieldsValue(roleDetail);
      }, 100);
    }
  }, [roleDetail]);

  const loadData = () => {
    listRoles().then((info: any) => {
      setRoles(info?.data);
      // console.log("info:" + JSON.stringify(info.data));
    });
    listPermissions().then((info: any) => {
      setPermissions(info?.data);
    });
    listMenus().then((info: any) => {
      setMenus(info?.data);
    });
  }

  const onFinish = (values: any) => {
    setLoading(true);
    if (roleDetail) {
      updateRole({
        ...values,
        id: roleDetail.id
      }).then((info: any) => {
        // console.log("info:" + JSON.stringify(info));
        if (info) {
          message.success("更新成功");
          onClose();
          setLoading(false);
          loadData();
        }
      });
    } else {
      createRole(values).then((info: any) => {
        // console.log("info:" + JSON.stringify(info));
        if (info) {
          message.success("创建成功");
          onClose();
          setLoading(false);
          loadData();
        }
      });
    }
  };

  // const onEnable = (e: any, item: IRolePermission) => {
  //   e.stopPropagation();
  //   confirm({
  //     title: '提示',
  //     icon: <ExclamationCircleOutlined />,
  //     content: item.enable?'确定要停用该角色吗？停用后无法被选到':'确定要启用该角色吗？',
  //     okText: '确定',
  //     okType: 'danger',
  //     cancelText: '取消',
  //     onOk() {
  //       enableRole(item.id, !item.enable).then((info: any) => {
  //         // console.log("info:" + JSON.stringify(info));
  //         message.success("操作成功");
  //         loadData();
  //       });
  //     },
  //     onCancel() {
  //     },
  //   });
  // }

  const onClose = () => {
    setRoleDetail(undefined);
    setVisible(false);
    if (formRef.current) {
      formRef.current!.resetFields();
    }
  }

  // 下拉框值
  const menuOptions = menus?.map((menu) =>
    <Option key={menu.id} value={menu.id}>{menu.name}</Option>);

  // 下拉框值
  const permissionOptions = permissions?.map((permission) =>
    <Option key={permission.id} value={permission.id}>{permission.name}</Option>);

  return (
    <Card bordered={false}>
      <Table dataSource={roles} columns={columns} pagination={false} />
      <div style={{ display: "flex", justifyContent: "flex-end", paddingTop: "10px" }}>
      </div>
      <Drawer
        title={roleDetail ? "编辑角色" : "新增角色"}
        visible={visible}
        width={720}
        onClose={onClose}
        bodyStyle={{ paddingBottom: 80 }}
        destroyOnClose
      >
        <Form onFinish={onFinish} ref={formRef} layout="vertical" hideRequiredMark>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="名称"
                rules={[{ required: true, message: '请输入名称' }]}
              >
                <Input placeholder="请输入名称" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="code"
                label="编码"
                rules={[{ required: true, message: '请输入编码' }]}
              >
                <Input placeholder="请输入编码" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="menuIds"
                label="拥有菜单"
                rules={[{ required: true, message: '请选择菜单列表' }]}
              >
                <Select placeholder="请选择菜单列表" mode="multiple" >
                  {menuOptions}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="permissionIds"
                label="拥有权限"
                rules={[{ required: true, message: '请选择权限列表' }]}
              >
                <Select placeholder="请选择权限列表" mode="multiple" >
                  {permissionOptions}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>保存</Button>
                <Button htmlType="button" onClick={onClose}>取消</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </Card>
  );
};

export default RoleList;
